module.exports = window.mobxReactLite;